import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Interceptor } from "components/Interceptor";
import { AuthProvider } from "context/AuthContext";
import { routes } from "./routes";

const App = () => {
  const renderRoutes = (routes) => {
    return routes.map(({ route, element, children }, index) =>
      children && children.length > 0 ? (
        <Route key={index.toString()} path={route}>
          <Route index element={element} />
          {renderRoutes(children)}
        </Route>
      ) : (
        <Route key={index.toString()} path={route} element={element} />
      ),
    );
  };

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>{renderRoutes(routes)}</Routes>
        <Interceptor />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
